<template>
    <div>
        <div v-if="loading" class="loader-container">
            <div class="loader"></div>
        </div>
        <div class="row">
            <div class="col-md-24">
                <card>
                    <template slot="header">
                        <h5 class="card-category"></h5>
                        <h3 class="card-title">Rent-a-car izveštaji ({{ totalRecords }}) ({{ totalPrice }} EUR)</h3>
                    </template>
                    
                    <!-- Filteri -->
                    <div class="row">
                        <div class="col-md-3">
                            <h4 slot="header" class="card-title">Početak</h4>
                            <base-input>
                                <el-date-picker type="datetime" placeholder="Početak" value-format="timestamp"
                                    format="dd.MM.yyyy. HH:mm:ss" v-model="filter.startStamp">
                                </el-date-picker>
                            </base-input>
                        </div>
                        <div class="col-md-3">
                            <h4 slot="header" class="card-title">Kraj</h4>
                            <base-input>
                                <el-date-picker type="datetime" placeholder="Kraj" value-format="timestamp"
                                    format="dd.MM.yyyy. HH:mm:ss" v-model="filter.endStamp">
                                </el-date-picker>
                            </base-input>
                        </div>
                        <div class="col-md-3">
                            <h4 slot="header" class="card-title">Rent-a-car agencija</h4>
                            <base-input>
                                <el-select v-model="filter.rentCarId" class="select-primary" name="rentCar" clearable
                                    placeholder="Sve agencije">
                                    <el-option v-for="rc in rentCars" class="select-primary" :label="rc.name"
                                        :value="rc.id" :key="rc.id"></el-option>
                                </el-select>
                            </base-input>
                        </div>
                        <div class="col-md-3">
                            <h4 slot="header" class="card-title">Status plaćanja</h4>
                            <base-input>
                                <el-select v-model="filter.paymentStatusId" class="select-primary" name="paymentStatus" clearable
                                    placeholder="Svi statusi">
                                    <el-option v-for="ps in paymentStatuses" class="select-primary" :label="ps.name"
                                        :value="ps.id" :key="ps.id"></el-option>
                                </el-select>
                            </base-input>
                        </div>
                    </div>
                    <div class="row" style="margin-top: 10px;">
                        <div class="col-md-3">
                            <base-button class="mt-3" native-type="submit" type="primary"
                                @click="getTickets()">Pretraži</base-button>
                        </div>
                    </div>

                    <!-- Export dugmad -->
                    <div class="row" style="margin-top: 15px; margin-bottom: 15px;">
                        <div class="col-md-12">
                            <base-button v-if="tickets.length > 0" type="success" @click="getExcel()">
                                <i class="tim-icons icon-cloud-download-93"></i> Preuzmi Excel
                            </base-button>
                            <base-button v-if="tickets.length > 0" type="info" @click="getPdf()">
                                <i class="tim-icons icon-paper"></i> Preuzmi PDF
                            </base-button>
                        </div>
                    </div>

                    <!-- Tabela -->
                    <el-table :data="tickets" v-loading="ticketsLoading" @sort-change="handleSort"
                        :default-sort="{ prop: sortField, order: sortOrder }">

                        <el-table-column min-width="100" prop="plates" label="Registracija" sortable="custom">
                            <template slot-scope="scope">
                                <span>{{ scope.row.plates }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="120" prop="stamp" label="Datum" sortable="custom">
                            <template slot-scope="scope">
                                <span>{{ formatDate(scope.row.stampLong) }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="80" prop="time" label="Vreme">
                            <template slot-scope="scope">
                                <span>{{ formatTime(scope.row.stampLong) }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="100" prop="client" label="Zona">
                            <template slot-scope="scope">
                                <span v-if="scope.row.client">{{ scope.row.client.name }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="180" prop="parking" label="Ulica">
                            <template slot-scope="scope">
                                <span v-if="scope.row.parking">{{ scope.row.parking.name }}</span>
                                <span v-else>{{ scope.row.parkingName }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="80" prop="price" label="Iznos" sortable="custom">
                            <template slot-scope="scope">
                                <span>{{ scope.row.price }} EUR</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="100" prop="rentCar" label="Rent-a-car">
                            <template slot-scope="scope">
                                <span>{{ scope.row.rentCarPlates?.rentCar?.name }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="100" prop="paymentStatus" label="Status">
                            <template slot-scope="scope">
                                <span v-if="scope.row.paymentStatus.id === '2'" style="color: red">{{
                                    scope.row.paymentStatus.name }}</span>
                                <span v-else-if="scope.row.paymentStatus.id === '1'" style="color: green">{{
                                    scope.row.paymentStatus.name }}</span>
                                <span v-else>{{ scope.row.paymentStatus.name }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="100" header-align="right" align="right" label="Akcije">
                            <div slot-scope="scope" class="text-right table-actions">
                                <base-button :type="'success'" class="btn-link" @click="getTicket(scope.row)">
                                    Detalji
                                </base-button>
                            </div>
                        </el-table-column>
                    </el-table>

                    <!-- Paginacija -->
                    <div class="block">
                        <span class="demonstration" style="color: white;">Ukupno stranica: {{ totalPages }}</span><br>
                        <base-pagination class="pagination-no-border" v-model="page" :per-page="max"
                            :total="totalRecords" @input="changeP">
                        </base-pagination>
                    </div>

                    <!-- Ukupan iznos -->
                    <div class="row" style="margin-top: 20px;">
                        <div class="col-md-12">
                            <h3 style="color: white; text-align: right;">
                                Ukupan iznos: <strong>{{ totalPrice }} EUR</strong>
                            </h3>
                        </div>
                    </div>
                </card>
            </div>
        </div>

        <!-- Modal za detalje -->
        <modal :show.sync="showTicket" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link" @click="showTicket = false; ticket = {}">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>

            <div class="row">
                <div class="col-md-12">
                    <card>
                        ID: {{ ticket.ticketNumber }}&nbsp;&nbsp;&nbsp;
                        {{ ticket.plates }}&nbsp;&nbsp;&nbsp;
                        <template v-if="ticket.checkedPlates">
                            {{ (new Date(ticket.checkedPlates?.stamp)).toLocaleString("de-DE") }} -
                        </template>
                        {{ (new Date(ticket.stamp)).toLocaleString("de-DE") }}&nbsp;&nbsp;&nbsp;
                        {{ ticket.exceded }}
                    </card>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <card v-if="ticket.parking">
                        {{ ticket.parking?.client.name }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        {{ ticket.parking?.name }} - Parking mesto: {{ ticket.parkingSpace?.number
                        }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        {{ ticket.countryMark }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        {{ ticket.price }} EUR
                    </card>
                    <card v-else>
                        {{ ticket.client?.name }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        {{ ticket.parkingName }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        {{ ticket.countryMark }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        {{ ticket.price }} EUR
                    </card>
                </div>
            </div>

            <tabs type="primary">
                <tab-pane label="Doplatna karta">
                    <template>
                        <img v-for="img in ticket.images" class="card-img" style="width: 150px;" :key="img"
                            @click="image = 'https://budva.scancar.org:8443' + img; showImage = true"
                            :src="'https://budva.scancar.org:8443' + img" alt="Image" />&nbsp;
                    </template>
                </tab-pane>

                <tab-pane v-if="ticket.checkedPlates" label="Prvo skeniranje">
                    <template>
                        <img v-for="img in ticket.checkedPlates?.images" class="card-img" style="width: 150px;"
                            :key="img" @click="image = 'https://budva.scancar.org:8443' + img; showImage = true"
                            :src="'https://budva.scancar.org:8443' + img" alt="Image" />&nbsp;
                    </template>
                </tab-pane>
            </tabs>
        </modal>

        <!-- Modal za sliku -->
        <modal :show.sync="showImage" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link" @click="showImage = false; image = null">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>
            <card class="stacked-form" title="Stacked Form">
                <h4 slot="header" class="card-title">{{ ticket.plates }}</h4>
                <img class="card-img" :src="image" alt="Image" />&nbsp;
            </card>
        </modal>
    </div>
</template>

<script>
import { TabPane, Tabs, BasePagination } from 'src/components';
import { Table, TableColumn, DatePicker, Select, Option } from 'element-ui';
import axios from '@/util/axiosinstance';
import { BaseNav, Modal } from '@/components';

export default {
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [DatePicker.name]: DatePicker,
        [Option.name]: Option,
        [Select.name]: Select,
        TabPane,
        Tabs,
        Modal,
        BasePagination
    },
    mounted() {
        this.getRentCars();
        this.getPaymentStatuses();
        this.getTickets();
    },
    data() {
        const now = new Date();
        const startStamp = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0).getTime();
        const endStamp = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59).getTime();

        return {
            url: 'https://budva.scancar.org:8443/kuca',
            fileUrl: 'https://budva.scancar.org:8443',
            loading: false,
            ticketsLoading: false,
            tickets: [],
            rentCars: [],
            paymentStatuses: [],
            filter: {
                startStamp: startStamp,
                endStamp: endStamp,
                rentCarId: null,
                paymentStatusId: null
            },
            ticket: {},
            showTicket: false,
            image: null,
            showImage: false,
            page: 1,
            max: 100,
            totalRecords: 0,
            totalPages: 0,
            totalPrice: 0,
            sortField: "stamp",
            sortOrder: "descending"
        };
    },
    methods: {
        formatDate(timestamp) {
            if (!timestamp) return '';
            const date = new Date(timestamp);
            return date.toLocaleDateString("de-DE");
        },
        formatTime(timestamp) {
            if (!timestamp) return '';
            const date = new Date(timestamp);
            return date.toLocaleTimeString("de-DE", { hour: '2-digit', minute: '2-digit' });
        },
        changeP(item) {
            this.page = item;
            this.getTickets();
        },
        handleSort({ prop, order }) {
            this.sortField = prop;
            this.sortOrder = order;
            this.getTickets();
        },
        getRentCars() {
            axios.get(this.url + '/whitelist/getRentCars').then(result => {
                if (result.data.result === 'ok') {
                    this.rentCars = result.data.rentCars;
                }
            });
        },
        getPaymentStatuses() {
            axios.get(this.url + '/settings/getPaymentStatuses').then(result => {
                if (result.data.result === 'ok') {
                    this.paymentStatuses = result.data.paymentStatuses;
                }
            });
        },
        getTickets() {
            this.ticketsLoading = true;
            this.loading = true;

            const f = {
                startStamp: this.filter.startStamp,
                endStamp: this.filter.endStamp,
                rentCarId: this.filter.rentCarId,
                paymentStatusId: this.filter.paymentStatusId,
                page: this.page,
                max: this.max,
                sortField: this.sortField,
                sortOrder: this.sortOrder
            };

            axios.post(this.url + '/ticket/getRentCarTickets', f).then(result => {
                this.ticketsLoading = false;
                this.loading = false;

                if (result.data.result === 'ok') {
                    this.tickets = result.data.tickets;
                    this.totalPages = result.data.totalPages;
                    this.totalRecords = result.data.totalRecords;
                    this.totalPrice = result.data.totalPrice;
                } else {
                    this.$notify({
                        message: result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            });
        },
        getTicket(t) {
            this.loading = true;
            axios.get(this.url + '/ticket/getTicket?id=' + t.id).then(result => {
                this.loading = false;
                if (result.data.result === 'ok') {
                    this.ticket = result.data.ticket;
                    this.showTicket = true;
                } else {
                    this.$notify({
                        message: result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            });
        },
        getExcel() {
            this.loading = true;
            const body = {
                startStamp: this.filter.startStamp,
                endStamp: this.filter.endStamp,
                rentCarId: this.filter.rentCarId,
                paymentStatusId: this.filter.paymentStatusId
            };

            axios.post(this.url + '/ticket/getRentCarExcel', body).then(result => {
                this.loading = false;
                if (result.data.result === 'ok') {
                    const link = document.createElement('a');
                    link.href = this.fileUrl + "/opomene/" + result.data.fileName;
                    link.download = "";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } else {
                    this.$notify({
                        message: result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            });
        },
        getPdf() {
            this.loading = true;
            const body = {
                startStamp: this.filter.startStamp,
                endStamp: this.filter.endStamp,
                rentCarId: this.filter.rentCarId,
                paymentStatusId: this.filter.paymentStatusId
            };

            axios.post(this.url + '/ticket/getRentCarPdf', body).then(result => {
                this.loading = false;
                if (result.data.result === 'ok') {
                    const link = document.createElement('a');
                    link.href = this.fileUrl + "/opomene/" + result.data.fileName;
                    link.download = "";
                    link.target = "_blank";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } else {
                    this.$notify({
                        message: result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            });
        }
    }
};
</script>

<style lang="scss">
.custom-modal {
    background-color: rgba(0, 0, 0, 0.8);
}

.custom-modal-content {
    background-color: #3b3b5c;
    color: #ffffff;
    border-radius: 8px;
    max-width: 800px;
    width: 800px;
}

.custom-modal-body {
    padding: 20px;
}

.loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: rgba(255, 255, 255, 0.7);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
}

.loader {
    border: 8px solid #f3f3f3;
    border-top: 8px solid #3498db;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>